export const home = {
  title: 'Çevresel Etkileri Azaltmak İçin En İyi Mevcut Teknolojiler ve Önlemler',
  headerDescription:
    "Inditex olarak, faaliyetlerimizin çevresel etkilerini radikal bir şekilde azaltmayı taahhüt ediyoruz. Endüstrimizin geleceğini dönüştürmek için hep birlikte iş birliği yapmamız gerektiğine gerçekten inanıyoruz. Bu nedenle, boya, baskı, yıkama ve deri ile ilgili faaliyetlerde bulunan ıslak proses üreticilerini desteklemek amacıyla uzmanlarla birlikte bu aracı geliştirdik.",
  headerButton: 'Keşfet',
  techMeasuresTab: 'Teknoloji ve Önlemler',
  renewableEnergyTab: 'Yenilenebilir Enerji',
  techMeasureDetail: 'Teknoloji ve Önlem Detayları',
  footerText: 'Yardıma ihtiyacınız var mı veya geri bildiriminizi paylaşmak mı istiyorsunuz?',
  manufacturingProcessSelection: 'Üretim Süreci Seçimi',
  manufacturingProcessTitle: 'Uzmanlığınızı hangi üretim süreci tanımlar?',
  contactUs: 'Bize Ulaşın'
};